export const API_URL = 'https://cbd477uzwd.execute-api.ap-south-1.amazonaws.com/prod';
// export const API_URL = 'http://localhost:8080';
// export const API_URL = 'https://equally-content-stud.ngrok-free.app';
